import {Component, input, model} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {BaseInput} from '../base-input/base-input';

@Component({
  selector: 'app-text',
  imports: [
    FormsModule
  ],
  templateUrl: './text.html',
  styleUrl: './text.css',
})
export class Text extends BaseInput {
  value = model<string | number>('');
  maxlength = input<number>();
  minlength = input<number>();
  labelBackground = input<string>('bg-white dark:bg-gray-900');
  autocomplete = input<string>();
  inputmode = input<string>('text');
}
